import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Rentals from "../components/Rentals";

const RentalsPage = () => {
  return (
    <>
      <Header />
      <Rentals />
      <Footer />
    </>
  );
};

export default RentalsPage;
